import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import UIGrid from '@material-ui/core/Grid'
import useMediaQuery from '@material-ui/core/useMediaQuery'

const styles = theme => ({
  root: {
    display: 'flex',
    overflow: 'hidden',
  },
  item: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
//    padding: theme.spacing(0, 3),
  },
});

const Grid = (props) => {
  const { theme, classes, color, item_size, item_count, items, image_position, image_alternate_position, item_spacing, createItemBlock } = props
  
  let removeNotFullRow = false
  let smUp = useMediaQuery(theme.breakpoints.up('sm'))
  let mdUp = useMediaQuery(theme.breakpoints.up('md'))
  let lgUp = useMediaQuery(theme.breakpoints.up('lg'))
  let xlUp = useMediaQuery(theme.breakpoints.up('xl'))
  let spacing
  let itemsPerRow
  
  if (item_size == 's') {
    if (xlUp) {
      itemsPerRow = 6
      spacing = 3
    }else if (lgUp) {
      itemsPerRow = 6
      spacing = 3
    }else if (mdUp) {
      itemsPerRow = 6
      spacing = 3
    }
    else if (smUp) {
      itemsPerRow = 4
      spacing = 2
    }
    else {
      itemsPerRow = 2
      spacing = 1
    }
  }
  else if (item_size == 'l') {
    if (xlUp) {
      itemsPerRow = 1
      spacing = 1
    }else if (lgUp) {
      itemsPerRow = 2
      spacing = 1
    }else if (mdUp) {
      itemsPerRow = 2
      spacing = 1
    }
    else if (smUp) {
      itemsPerRow = 2
      spacing = 1
    }
    else{
      itemsPerRow = 1
      spacing = 0
    }
  }
  else if (item_size == 'xl') {
    if (xlUp) {
      itemsPerRow = 1
      spacing = 1
    }else if (lgUp) {
      itemsPerRow = 1
      spacing = 1
    }else if (mdUp) {
      itemsPerRow = 1
      spacing = 1
    }
    else if (smUp) {
      itemsPerRow = 1
      spacing = 1
    }
    else{
      itemsPerRow = 1
      spacing = 1
    }
  }
  else {
    if (xlUp) {
      itemsPerRow = 3
      spacing = 3
    }else if (lgUp) {
      itemsPerRow = 3
      spacing = 3
    }else if (mdUp) {      
      itemsPerRow = 3
      spacing = 3
    }
    else if (smUp) {
      itemsPerRow = 3
      spacing = 2
    }
    else {
      itemsPerRow = 2
      spacing = 1
    }
  }
  
  let filteredItems = items
  if (items !== undefined && removeNotFullRow) {
    let rowCount = Math.floor(items.length / itemsPerRow)
    if (rowCount <= 0)
      filteredItems = items
    else
      filteredItems = items.slice(0, rowCount * itemsPerRow)
  }else if(items !== undefined && item_size === 'xl'){
    let rowCount = Math.floor(items.length / itemsPerRow)
    filteredItems = items.slice(0, rowCount * itemsPerRow)
    items.map((item,index) => {
        filteredItems[index]['itemIndex'] = index
        if(index % 2 === 1){
          filteredItems[index]['positionImage'] = image_alternate_position
        }else{
          filteredItems[index]['positionImage'] = image_position
        }
    })
  }

  let itemStyle = []
  itemStyle['padding'] = item_spacing+'%'
      
  return (
    <UIGrid container justify='center'>
    { filteredItems !== undefined && filteredItems.map((item,index) => (
      <UIGrid item xs={12/itemsPerRow} style={itemStyle}>
      { 
        createItemBlock(item, index)
      }
      </UIGrid>
      )) 
    }
    </UIGrid>
  )
}

Grid.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Grid);